import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AsyncRoute from "./AsyncRoute";
import Application from "./Application";
import SignIn from "./SignIn/container";
import { ROUTES } from "../utils/constants";

const Entry = () => (
  <BrowserRouter>
    <Routes>
      <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
      <Route path="*" element={<AsyncRoute component={Application} />} />
    </Routes>
  </BrowserRouter>
);

export default Entry;
